import { AddressItem } from "./AddressItem";

export default AddressItem;